import { App } from 'vue';

import BaseInput from "@/components/forms/BaseInput.vue";
import BaseLabel from "@/components/forms/BaseLabel.vue";

import BaseButton from "@/components/buttons/BaseButton.vue";
import EditButton from '@/components/buttons/EditButton.vue';
import DeleteButton from '@/components/buttons/DeleteButton.vue';
import CancelButton from '@/components/buttons/CancelButton.vue';
import SaveButton from '@/components/buttons/SaveButton.vue';
import ButtonGroup from "@/components/buttons/ButtonGroup.vue";

import BaseModal from "@/components/modals/BaseModal.vue";

import BadgeWithClose from '@/components/badges/BadgeWithClose.vue';

export default {
  install(app: App) {
    app.component('bs5-base-button', BaseButton);
    app.component('bs5-edit-button', EditButton);
    app.component('bs5-delete-button', DeleteButton);
    app.component('bs5-cancel-button', CancelButton);
    app.component('bs5-save-button', SaveButton);
    app.component('bs5-group-button', ButtonGroup);
    app.component('bs5-base-input', BaseInput);
    app.component('bs5-base-label', BaseLabel);

    app.component('bs5-base-modal', BaseModal);

    app.component('bs5-badge-with-close', BadgeWithClose);
  }
};
